import type { Device, Recorder } from '../types';

export const recorderToDevice = (recorder: Recorder): Device => ({
  id: recorder.id,
  name: recorder.name,
  type: 'recorder',
  status: recorder.status,
  backendStatus: recorder.status === 'online' ? 2 : 3,
  isOnline: recorder.status === 'online',
  health: recorder.status === 'online' ? 94 : 20,
  ip: recorder.ip,
  port: 0,
  location: recorder.location,
  vendor: 'Korsa NVR',
  model: `${recorder.channels}-channel recorder`,
  lastResponse: recorder.lastResponse,
  lastSeen: new Date().toISOString(),
  telemetry: {
    cpu: 31,
    ram: 46,
    uptimeHours: 688,
    networkInMbps: 42.4,
    networkOutMbps: 18.2,
    latencyMs: 4,
    packetLoss: 0,
    heartbeat: 100,
  },
  role: `${recorder.usedChannels} из ${recorder.channels} каналов занято`,
});
